<template>
  <div class="xu-select">
    <div class="field-txt" @click="handleOper">
      <span class="txt-label van-ellipsis" :class="{'isDisable': disabled, 'placeholder-custom': !showVal}">{{ showVal ? showVal : placeholder }}</span>
      <van-icon name="arrow-down" />
    </div>
    <van-popup v-model="selectShow" position="bottom" :round="true" :style="{ 'min-height': '266px' }" get-container="#app">
      <div class="other-content">
        <div class="filter-popup-title">{{ $t('shared.filter.filter') }}</div>
        <div class="filter-popup-content" style="max-height: 436px; min-height: 266px">
          <div v-for="(otherItem, otherIndex) in dataOptions" :class="{'active-status': selectVal.value.includes(otherItem[fieldNames.value]) }" @click="changeVal(otherItem)" :key="otherIndex" class="item-content">
            {{ otherItem[fieldNames.label] }}
          </div>
        </div>
        <div class="operate-btn">
          <van-button type="primary" @click="filterOtherReset">{{ $t('button.reset') }}</van-button>
          <van-button class="confirm-btn" type="primary" @click="confirmFilter">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    dataOptions: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fieldNames: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          value: 'value'
        }
      }
    },
    value: {
      type: [String, Array, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: {
      handler (newVal) {
        if (!['', null, undefined].includes(newVal) && (typeof newVal === 'number' || newVal.length > 0)) {
          // 多选
          this.selectVal = {
            label: [],
            value: []
          }
          if (this.multiple) {
            const label = []
            this.dataOptions.forEach((subItem) => {
              if (newVal.includes(subItem[this.fieldNames.value])) {
                label.push(subItem[this.fieldNames.label])
                this.selectVal.value.push(subItem[this.fieldNames.value])
                this.selectVal.label.push(subItem[this.fieldNames.label])
              }
            })
            this.showVal = label.join(',')
          } else {
            this.dataOptions.find((subItem) => {
              if (newVal === subItem[this.fieldNames.value]) {
                this.showVal = subItem[this.fieldNames.label]
                // this.selectVal.value.push(subItem[this.fieldNames.value])
                this.selectVal.value = [subItem[this.fieldNames.value]]
                // this.selectVal.label.push(subItem[this.fieldNames.label])
                this.selectVal.label = [subItem[this.fieldNames.label]]
                return subItem
              }
            })
          }
        } else {
          this.selectVal = {
            label: [],
            value: []
          }
          this.showVal = ''
        }
      },
      immediate: true
    },
    selectShow (newVal) {
      // if (!newVal && this.value.length <= 0) {
      if (!newVal && (this.value === '' || this.value === null || this.value === undefined || (Array.isArray(this.value) && this.value.length <= 0))) {
        this.selectVal = {
          label: [],
          value: []
        }
        this.showVal = ''
      }
    }
  },
  data () {
    return {
      selectShow: false,
      selectVal: {
        label: [],
        value: []
      },
      showVal: ''
    }
  },
  methods: {
    changeVal (params) {
      if (this.multiple) {
        // 如果已经选中，再次点击即删除
        if (this.selectVal.value.includes(params[this.fieldNames.value])) {
          this.selectVal.value = this.selectVal.value.filter((subItem) => {
            return subItem !== params[this.fieldNames.value]
          })
          this.selectVal.label = this.selectVal.label.filter((subItem) => {
            return subItem !== params[this.fieldNames.label]
          })
        } else {
          this.selectVal.label.push(params[this.fieldNames.label])
          this.selectVal.value.push(params[this.fieldNames.value])
        }
      } else {
        this.selectVal.label = [params[this.fieldNames.label]]
        this.selectVal.value = [params[this.fieldNames.value]]
      }
    },
    filterOtherReset () {
      this.selectVal = {
        label: [],
        value: []
      }
      this.showVal = ''
      this.confirmFilter()
      this.selectShow = false
    },
    confirmFilter () {
      this.showVal = this.selectVal.label.join(',')
      if (this.multiple) {
        this.$emit('input', this.selectVal.value)
      } else {
        // this.$emit('input', this.selectVal.value.join(','))
        this.$emit('input', this.selectVal.value[0])
      }
      this.selectShow = false
    },
    handleOper () {
      if (this.disabled) return
      this.selectShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.xu-select {
  width: 100%;
  font-size: 12px;
  .field-txt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 0px 10px;
    border: 1px solid #b9cbed;
    border-radius: 5px;
    .txt-label {
      flex: 1;
      color: #000;
    }
    .isDisable {
      color: #c8c9cc;
    }
    .placeholder-custom {
      color: #969799;
    }
  }
}
.other-content {
  padding: 10px 18px 20px 18px;
  .filter-popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .filter-popup-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    align-content: start;
    overflow: auto;
    .item-title {
      width: 100%;
      color: #000;
      font-weight: bold;
      font-size: 12px;
      padding: 7px 0;
    }
    .item-content {
      width: 48%;
      height: 27px;
      color: #000;
      text-align: center;
      line-height: 27px;
      font-size: 11px;
      background-color: #f3f6fc;
      border-radius: 6px;
      margin-top: 5px;
      margin-bottom: 5px;
      // padding: 0 5px;
      margin-right: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .active-status {
      background-color: #1989fa;
      color: #fff;
    }
    .project-item {
      display: flex;
      align-items: center;
      padding: 10px;
      height: 47px;
      font-size: 12px;
      border-bottom: 1px solid #dce5f6;
    }
    .choice-active {
      color: #307bff;
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
    /deep/.van-button {
      width: 126px;
      height: 40px;
      background-color: #dce5f6;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      color: #000;
    }
    .confirm-btn {
      width: 190px;
      color: #fff;
      background-color: #307bff;
      border: 1px solid #307bff;
    }
  }
}
</style>
